<template>
  <div id="dialogEditAlumno">
    <v-dialog v-model="getEditAlumnoDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Editar Información de Usuario</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAlumnoEdit.codigoUNI"
                  label="Correo electrónico UNI"
                  required
                  outlined
                  dense
                  readonly
                  hint="No se puede cambiar"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAlumnoEdit.correoUNI"
                  label="Correo electrónico UNI"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAlumnoEdit.correoAlternativo"
                  label="Correo electrónico Personal"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="updateDatosAlumno()"> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters("admin", ["getEditAlumnoDialog", "getSelectedAlumnoEdit"])
  },

  methods: {
    async updateDatosAlumno() {
      let success = await this.fetchUpdateDatosAlumno(
        this.getSelectedAlumnoEdit
      );
      if (success) {
        this.setNoChangeEdit(false);
        this.setEditAlumnoDialog(false);
      }
    },

    closeDialog() {
      this.setNoChangeEdit(true);
      this.setEditAlumnoDialog(false);
    },

    ...mapMutations("admin", ["setEditAlumnoDialog", "setNoChangeEdit"]),

    ...mapActions("admin", ["fetchUpdateDatosAlumno"])
  }
};
</script>

<style>
</style>